define(["require", "exports", "tslib", "@arcgis/core/geometry/SpatialReference"], function (require, exports, tslib_1, SpatialReference_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SpatialReferenceFactory = void 0;
    SpatialReference_1 = tslib_1.__importDefault(SpatialReference_1);
    class SpatialReferenceFactory {
        static findOptimalProjectionFromGeographicCoordSystem(point) {
            if (point.spatialReference && point.spatialReference.wkid === this.GDA_1994.wkid) {
                const longitude = point.x;
                if (longitude < 144) {
                    return this.GDA_1994_MGA_Zone_54;
                }
                else if (longitude < 150) {
                    return this.GDA_1994_MGA_Zone_55;
                }
                else {
                    return this.GDA_1994_MGA_Zone_56;
                }
            }
            else {
                throw new Error("Could not find optimal projected coordinate system. The gemoetry has an unknown Geographic Coordinate System. Please Assign a Geographic Coordinate System to the Geometry before continuing");
            }
        }
        static getCoordinateSystemsAsKeyValueList() {
            return [
                { key: "GDA 1994 MGA Zone 56", value: this.GDA_1994_MGA_Zone_54 },
                { key: "GDA 1994 MGA Zone 56", value: this.GDA_1994_MGA_Zone_55 },
                { key: "GDA 1994 MGA Zone 56", value: this.GDA_1994_MGA_Zone_56 }
            ];
        }
    }
    exports.SpatialReferenceFactory = SpatialReferenceFactory;
    Object.defineProperty(SpatialReferenceFactory, "GDA_1994", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new SpatialReference_1.default({
            wkid: 4283,
            wkt: "GEOGCS['GDA94',DATUM['D_GDA_1994',SPHEROID['GRS_1980',6378137,298.257222101]],PRIMEM['Greenwich',0],UNIT['Degree',0.017453292519943295]]"
        })
    });
    Object.defineProperty(SpatialReferenceFactory, "GDA_1994_Lambert", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new SpatialReference_1.default({ wkid: 3112 })
    });
    Object.defineProperty(SpatialReferenceFactory, "GDA_1994_MGA_Zone_54", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new SpatialReference_1.default({ wkid: 28354 })
    });
    Object.defineProperty(SpatialReferenceFactory, "GDA_1994_MGA_Zone_55", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new SpatialReference_1.default({ wkid: 28355 })
    });
    Object.defineProperty(SpatialReferenceFactory, "GDA_1994_MGA_Zone_56", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new SpatialReference_1.default({ wkid: 28356 })
    });
});
